import { Spine } from 'pixi-spine';
import AssetsManager from '../../gamma-engine/core/assets/AssetsManager';
import { TrackEntry } from '@pixi-spine/runtime-4.1';
import { Tweener } from '../libs/engineTween';
import SoundManager from '../../gamma-engine/core/sound/SoundManager';
import SoundList from '../../gamma-engine/common/sound/SoundList';

export class GameTransitionAnimation extends Spine {
    private currentListener: { complete: (entry: TrackEntry) => void } | null = null;
    private currentTransitionPromise: Promise<void> | null = null;
    private currentTransitionName: string | null = null;
    private readonly animationTime: number = 2;
    constructor() {
        super(AssetsManager.spine.get('transition-animation'))

        this.on('added', this.onAdded, this)
    }

    private onAdded(): void {
        this.state.setEmptyAnimations(0);
        this.alpha = 0;
    }

    public setTransition(transitionName: string): Promise<void> {
    return new Promise((resolve) => {
        let resolved = false;
        const finish = () => {
            if (resolved) return;
            resolved = true;
            this.alpha = 0;
            this.state.removeListener(listener);
            Tweener.removeTweens(this);
            resolve();
        };
        const listener = {
            complete: (entry: TrackEntry) => {
                if (entry.animation.name === transitionName) {
                    finish();
                }
            }
        };
        this.state.setAnimation(0, transitionName, false);
        this.alpha = 1;
        SoundManager.play(SoundList.TRANSITION);
        this.state.addListener(listener);

        Tweener.addTween(this, {
            time: this.animationTime,
            onComplete: finish
        });
    });
}
}
